var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('TypeDisplay',{staticClass:"mb-[19px] text-headTitle text-grayHeader tracking-[0.1px] text-center xl:text-left font-poppins",attrs:{"tag":"h1"}},[_vm._v("\n  "+_vm._s(_vm.title)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }